// Export field definitions for customizable CSV exports
export interface ExportField {
  key: string;
  label: string;
  category: 'basic' | 'address' | 'enrichment' | 'metadata';
  default: boolean;
  description?: string;
}

export interface ExportFieldsResponse {
  data: {
    fields: ExportField[];
    defaultFields: string[];
    categories: {
      basic: string;
      address: string;
      enrichment: string;
      metadata: string;
    };
  };
  correlationId: string;
}

export interface ExportRequest {
  selectedFields: string[];
  // Extend existing QueryFilters
  license_types?: string[];
  license_type_status?: string[];
  premise_county?: string[];
  cities?: string[];
  business_name?: string;
  exclude_chains?: boolean;
  hasPhone?: boolean;
}

export const FIELD_CATEGORIES = {
  basic: 'Basic Information',
  address: 'Address Information', 
  enrichment: 'Google Places Data',
  metadata: 'System Information'
} as const;
